import React, { useEffect, useRef, useState } from 'react';
import PageContainer from '../../components/PageContainer';
import MainContent from '../../components/MainContent';
import PageTitle from '../../components/Common/PageTitle/PageTitle';
import ActionDropdownItem from '../../components/Common/PageTitle/ActionDropdownItem';
import Pagination from '../../components/Common/Pagination';
import ActivityLoader from '../../components/Common/ActivityLoader';
import Notification from '../../components/Common/Notification';
import printContent, { numberFormat } from '../../util/araknerdlib';
import ajaxSchool from '../../util/remote/ajaxSchool';
import AdvanceReconcileModal from '../../components/SchoolFees/Student/AdvanceReconcileModal';

const AdvanceFeesPage = () => {

    const [listing, setListing] = useState(null);
    const [metaData, setMetaData] = useState(null);
    const [currentPage, setCurrentPage] = useState(1);
    const [searchInput, setSearchInput] = useState('');
    const [searchText, setSearchText] = useState('');
    const [info, setInfo] = useState(null);
    const [selectedStudent, setSelectedStudent] = useState(null);
    const listRef = useRef();

    useEffect(()=>{
        getListing();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [currentPage, searchText])

    const getListing = async () => {
        setListing(null);
        setInfo(null);
        const server_response = await ajaxSchool.fetchAdvanceFeesList({
            page: currentPage,
            search: searchText,
        });
        if(server_response.status === "OK"){
            setListing(server_response.details.data);
            const meta = server_response.details.meta;
            // total arrives as a string or a number depending on whether search was used
            setMetaData({ ...meta, total: Number(meta.total) || 0 });
        }else{
            setListing("404");
            setMetaData(null);
            setInfo(<Notification message={server_response.message} closable={false} />);
        }
    };

    const handleSearch = (e) => {
        e.preventDefault();
        setCurrentPage(1);
        setSearchText(searchInput.trim());
    };

    const PageActions = ()=>(<>
        <ActionDropdownItem iconClass="fa fa-print" label="Print List" onClick={()=>printContent(listRef, "Advance & Overpaid Fees")}/>
        <ActionDropdownItem iconClass="fa fa-refresh" label="Refresh" onClick={()=>getListing()}/>
    </>)

    return (
        <>
        <PageContainer>
            <MainContent>
                <PageTitle
                    title="Advance & Overpaid Fees"
                    description="View fees advances and overpaid fee votes, and apply advances to outstanding votes."
                    iconClass="fa fa-hand-holding-usd"
                    PageActions={PageActions}
                    sticky={true}
                    Pagination={metaData ? <Pagination
                        metaData={metaData}
                        onPageChange={(page) => setCurrentPage(page)}
                        loadMore={false}
                    /> : <></>}
                />

                <div className="card">
                    <div className="card-body">
                        <form className="form-inline mb-3" onSubmit={handleSearch}>
                            <input
                                className="form-control mr-2"
                                placeholder="Search reg no. or name"
                                value={searchInput}
                                onChange={(e)=>setSearchInput(e.target.value)}
                            />
                            <button className="btn btn-primary" type="submit">
                                <i className="fa fa-search mr-1"></i> Search
                            </button>
                        </form>

                        <div ref={listRef} className='table-responsive'>
                            <table className="table table-hover table-striped table-bordered">
                                <thead>
                                    <tr>
                                        <th>Student Name</th>
                                        <th>Reg No.</th>
                                        <th>Class</th>
                                        <th className="text-right">Advance</th>
                                        <th className="text-right">Allocated</th>
                                        <th className="text-right">Unallocated</th>
                                        <th className="text-right">Overpaid Votes</th>
                                        <th className="text-right">Outstanding</th>
                                        <th></th>
                                    </tr>
                                </thead>
                                <tbody>
                                {Array.isArray(listing) && listing.map((item)=>
                                    <tr key={item.student.id}>
                                        <td>{item.student.full_name}</td>
                                        <td>{item.student.reg_no}</td>
                                        <td>{item.student.class?.class_name || ''}</td>
                                        <td className="text-right">{numberFormat(item.advance_total)}</td>
                                        <td className="text-right">{numberFormat(item.allocated)}</td>
                                        <td className="text-right text-success">{numberFormat(item.unallocated)}</td>
                                        <td className="text-right text-danger">{numberFormat(item.overpaid_total)}</td>
                                        <td className="text-right">{numberFormat(item.outstanding_total)}</td>
                                        <td className="text-center">
                                            <button className="btn btn-sm btn-outline-primary" onClick={()=>setSelectedStudent(item.student.id)}>
                                                View
                                            </button>
                                        </td>
                                    </tr>
                                )}
                                </tbody>
                            </table>
                        </div>
                        {!listing && <ActivityLoader />}
                        {info}
                    </div>
                </div>
            </MainContent>
        </PageContainer>
        <AdvanceReconcileModal
            show={!!selectedStudent}
            studentId={selectedStudent}
            onClose={()=>setSelectedStudent(null)}
            onReconciled={()=>getListing()}
        />
        </>
    );
};

export default AdvanceFeesPage;
